/**
 * Utility functions for interpreting counter-sale barcode structure.
 *
 * Counter-sale EAN-13 layout:
 *   PPPPPPP D SSSS C
 *   ─────── ─ ──── ─
 *   prefix  │ seq  checkdigit
 *            └─ type digit (from VoucherType.barcode_type_digits)
 *
 * The "Voucher ID" printed on the physical ticket = type-digit + 4-digit serial
 * = characters at positions 7–11 (0-indexed) of the EAN-13.
 */

/**
 * 7-digit global EAN prefix shared by all counter-sale voucher barcodes.
 *
 * Read from `window.__KARTIS_CONFIG__.ticketPrefix` injected by the backend at
 * page load, so changing `barcode.ticket_prefix` in the app config is
 * automatically reflected here without a frontend rebuild.
 * Falls back to the default value "8571654" when running outside the app
 * (e.g. Vite dev server without a backend, or unit tests).
 */
export const TICKET_PREFIX =
  window.__KARTIS_CONFIG__?.ticketPrefix ?? "8571654";

/**
 * Returns the 5-character Voucher ID (type digit + 4-digit serial) for a
 * counter-sale barcode, or null if the barcode does not start with TICKET_PREFIX.
 */
export function extractVoucherId(barcode: string): string | null {
  return barcode.startsWith(TICKET_PREFIX)
    ? barcode.slice(TICKET_PREFIX.length, TICKET_PREFIX.length + 5)
    : null;
}
